/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import {
  BuilderNavigationService,
} from '@gh/builder-shared';
import { NavTabBarComponent } from '@gh/common-internal-shared';
import { getRouteInitData, getRouteParentTitle, getRouteQueryParams } from '@gh/common-shared';
import { assign } from 'lodash';
import { JobDppDetailsGeneral } from '../../resources/job.model';
import { TranslationTupleOrId } from '@gh/core-mls';
const CURRENT_TAB = 'general';

@Component({
  selector: 'gh-job-dpp-details-container',
  template: require('./job-dpp-details-container.component.html'),

})
export class JobDppDetailsContainerComponent  implements OnInit {
  @ViewChild(NavTabBarComponent, { static: false }) navigation: NavTabBarComponent;
  queryParams: Params;
  details: JobDppDetailsGeneral;
  constructor(
              private navigationService: BuilderNavigationService,
              private route: ActivatedRoute) {
  }

  get currentTab(): string {
    return CURRENT_TAB;
  }

  get parentTitle(): TranslationTupleOrId {
    return getRouteParentTitle(this.route) || 'lbl_jobs';
  }

  ngOnInit(): void {
    const { details } = getRouteInitData(this.route);
    const queryParams = getRouteQueryParams(this.route);
    assign(this, { queryParams, details });
  }
}
